// extracted by mini-css-extract-plugin
export var boldText = "_67-4";
export var checkboxContainer = "_67-6";
export var closeIcon = "_67-i";
export var container = "_67-0";
export var drawer = "_67-8";
export var drawerContent = "_67-9";
export var extraSmallText = "_67-5";
export var fulfillmentGroupTable = "_67-e";
export var largeText = "_67-3";
export var loadingSpinnerContainer = "_67-j";
export var mediumText = "_67-2";
export var narrow = "_67-f";
export var notificationLink = "_67-l";
export var packageCheckIconContainer = "_67-7";
export var slideoutHeaderActions = "_67-g";
export var slideoutHeaderActionsShifted = "_67-h";
export var slideoutHeaderContainer = "_67-a";
export var slideoutModal = "_67-c";
export var stickyHeaderWrapper = "_67-b";
export var table = "_67-k";
export var tableContainer = "_67-d";
export var tertiaryText = "_67-1";